import React from "react";
import { Tabs } from "antd";
import VisibilityAnalysis from "./VisibilityAnalysis";
import AssistantTab from "./AssistantTab";
import { assistants, assistantsDisplayOrder } from "./assistants";
import { MULTI_ASSISTANT_VISIBILITY_ENABLED } from "../../settings/config";
import "./VisibilityAnalysis.less";

const { TabPane } = Tabs;

type Props = {
    domain: string;
}


export default function VisibilityAnalysisTabs({ domain }: Props) {
    /**
     * One report per assistant, each asking for its own analysis and nothing else.
     *
     * Inactive tabs are deliberately kept: a tab that has never been opened renders nothing, so
     * opening the page asks ChatGPT alone, and a tab that has been opened stays alive, so an
     * analysis that is still running keeps counting while the customer reads another tab.
     */

    // Where only one assistant is available there is nothing to choose between, so the report is
    // shown on its own and no tab strip is drawn at all.
    if (!MULTI_ASSISTANT_VISIBILITY_ENABLED) {
        return <VisibilityAnalysis domain={domain} modelFamily="gpt" />;
    }

    return (
        <Tabs className="visibility-analysis-assistant-tabs" type="card" animated={false}>
            {assistantsDisplayOrder.map((modelFamily) => (
                <TabPane key={modelFamily} tab={<AssistantTab assistant={assistants[modelFamily]} />}>
                    <VisibilityAnalysis domain={domain} modelFamily={modelFamily} />
                </TabPane>
            ))}
        </Tabs>
    );
}
